export function getInt(formData: FormData, key: string) {
    const value = formData.get(key);
    return parseInt(value as string);
}